define([
    "jquery",
    "underscore",
    "marionette"
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'selectAll': '#select_all',
            'selectBoxes': "input[type='checkbox'][id!='select_all']"
        },

        events:{
            'change @ui.selectAll': function(e){
                var that = this;
                this.allSelected = !this.allSelected;

                this.ui.selectBoxes.each(function(){
                    $(this).prop('checked', that.allSelected);
                });
            }
        },

        initialize: function(){
            this.bindUIElements();
            this.allSelected = false;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/support/banners_view_old.js
// module id = 48
// module chunks = 0